import { render, staticRenderFns } from "./DinnerStudent.vue?vue&type=template&id=118ab7a8&scoped=true&"
import script from "./DinnerStudent.vue?vue&type=script&lang=js&"
export * from "./DinnerStudent.vue?vue&type=script&lang=js&"
import style0 from "./DinnerStudent.vue?vue&type=style&index=0&id=118ab7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118ab7a8",
  null
  
)

export default component.exports